import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie } from '../types';
interface BoxBuilderProps {
  boxItems: Cookie[];
}
export function BoxBuilder({
  boxItems
}: BoxBuilderProps) {
  const minItems = 4;
  const canCheckout = boxItems.length >= minItems;
  const itemsNeeded = minItems - boxItems.length;
  const totalItems = boxItems.length;
  const isSixPack = totalItems >= 6;
  const isTwelvePack = totalItems >= 12;
  const getShippingMessage = () => {
    if (isTwelvePack) return '🎉 12-Pack! FREE SHIPPING + 2 EXTRA COOKIES!';
    if (isSixPack) return `🎉 6-Pack! Add ${12 - totalItems} more for 12-Pack & 2 free cookies!`;
    if (canCheckout) return `${totalItems} cookies — Add ${6 - totalItems} more for 6-Pack!`;
    return `Add ${itemsNeeded} more! (min 4)`;
  };
  const maxVisible = 6;
  const visibleItems = boxItems.slice(0, maxVisible);
  const overflowCount = totalItems - maxVisible;
  const emptySlots = Math.max(0, minItems - totalItems);
  return <motion.div initial={{
    y: 100
  }} animate={{
    y: 0
  }} className="fixed bottom-0 left-0 right-0 z-50 p-2 sm:p-3 pointer-events-none" style={{
    paddingBottom: 'max(0.5rem, env(safe-area-inset-bottom))'
  }} data-id="element-11">
      <div className="max-w-2xl mx-auto pointer-events-auto" data-id="element-12">
        <div className="bg-white/85 backdrop-blur-xl border border-white/50 shadow-glass rounded-xl p-2.5 sm:p-3 flex flex-col gap-2" data-id="element-13">
          {/* Top: message — always full width and visible */}
          <AnimatePresence mode="wait" data-id="element-14">
            <motion.p key={getShippingMessage()} initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} className={`text-xs sm:text-sm text-center ${isSixPack ? 'text-brand-purple font-bold' : 'text-brand-purple/80 font-medium'}`} data-id="element-15">
              {getShippingMessage()}
            </motion.p>
          </AnimatePresence>

          {/* Bottom: slots + checkout */}
          <div className="flex items-center justify-between gap-2" data-id="element-16">
            <div className="flex items-center gap-1 sm:gap-1.5 flex-shrink-0" data-id="element-17">
              {visibleItems.map((item, index) => <div key={index} className="w-7 h-7 sm:w-9 sm:h-9 rounded-md border-2 border-brand-purple overflow-hidden flex-shrink-0" data-id="element-18">
                  {item.image ? <img src={item.image} alt={item.name} className="w-full h-full object-cover" data-id="element-19" /> : <span className="flex items-center justify-center w-full h-full text-xs" data-id="element-20">
                      🍪
                    </span>}
                </div>)}
              {overflowCount > 0 && <div className="w-7 h-7 sm:w-9 sm:h-9 rounded-md bg-brand-purple text-white text-[10px] sm:text-xs font-bold flex items-center justify-center flex-shrink-0" data-id="element-21">
                  +{overflowCount}
                </div>}
              {[...Array(emptySlots)].map((_, index) => <div key={`empty-${index}`} className="w-7 h-7 sm:w-9 sm:h-9 rounded-md bg-brand-purple/10 border-2 border-dashed border-brand-purple/30 flex-shrink-0" data-id="element-22" />)}
            </div>

            <button disabled={!canCheckout} className={`flex-shrink-0 px-4 sm:px-6 py-2 sm:py-2.5 rounded-full font-bold text-xs sm:text-sm tracking-wide uppercase transition-all duration-300 shadow-md ${canCheckout ? isSixPack ? 'bg-brand-purple text-white hover:bg-brand-purple/90 animate-pulse' : 'bg-brand-purple text-white hover:bg-brand-purple/90' : 'bg-gray-300 text-gray-500 cursor-not-allowed'}`} data-id="element-23">
              CHECKOUT 🛒
            </button>
          </div>
        </div>
      </div>
    </motion.div>;
}